import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { formatCurrency } from 'js/services/Format';
import ItemDashboardStore from 'js/stores/pages/AdminDashboardPage/ItemDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import DropMenu from '../../DashPanel/DropMenu';
import Title from '../../DashPanel/Title';
import Controls from '../../DashPanel/Controls';

import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import { default as LinkTitle } from './Title';
import Price from './Price';
import Image from './Image';
import NotFound from './NotFound';

@observer
export default class Dashboard extends Component {
  itemList = ItemDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.itemList.load();
  }

  componentDidUpdate() {
    this.itemList.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.itemList.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Items</Title>
          <Controls>
            <Search model={this.itemList} options={{ title: 'Title', price: 'Price', alias: 'Alias' }} />
            <Pagination model={this.itemList} />
          </Controls>
        </Header>

        <Content>
          {this.itemList.isLoading ? (
            <LoadingSpinner />
          ) : this.itemList.items.length ? (
            <div>
              {this.itemList.items.map(item => (
                <Link key={item.alias} to={`item/${item.alias}`}>
                  <Image src={item.image} />
                  <Date>
                    {item.created_at} / {item.seller}
                  </Date>
                  <LinkTitle>
                    {item.title} (<Price>{formatCurrency(item.price)}</Price>, {item.location})
                  </LinkTitle>
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No items found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
